/**
 * Query-param helpers for multilocation rental display deeplinks (`?location_id=`).
 */

export const parseDisplayLocationId = (search) => {
  const raw = new URLSearchParams(search).get('location_id');
  if (raw == null || raw === '') return null;
  const id = parseInt(raw, 10);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const stripDisplayLocationId = (search) => {
  const params = new URLSearchParams(search);
  params.delete('location_id');
  const next = params.toString();
  return next ? `?${next}` : '';
};

/**
 * Returns true when `cached` is the same rental as the route `id` param.
 * Numeric params match rental DB id only; non-numeric params match token only,
 * avoiding false positives when a token string equals another rental's numeric id.
 */
export const isCachedRentalForNavigation = (cached, id) => {
  if (!cached) return false;
  const idParam = String(id);
  const isNumericId = /^\d+$/.test(idParam);
  if (isNumericId) {
    return cached.id != null && String(cached.id) === idParam;
  }
  return cached.token != null && String(cached.token) === idParam;
};
